import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { environment } from '../../environments/environment';
import { UserService } from './user.service';
import { FormGroup } from "@angular/forms";
import { TableResponse } from '../_model/table-response/table-response';
import { WorkOrderService } from './table/work-order.service';
import { ExportResponse } from '../_model/export-response/export-response';
import { catchError } from 'rxjs/operators';
import { User } from '../_model/user/user';
import { ExportData, UserData } from '../_model/export-response/user-data';
import { FilterDto } from '../_model/filterDto';
import { Constants } from '../_model/constants';
import { DatePipe } from '@angular/common';
import { VisitService } from "./table/visit.service";
import { Router } from "@angular/router";
import { MultipleFilterProperty } from "../_model/multiple-filter-property";

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  constructor(private http: HttpClient,
    private userService: UserService,
    private workOrderService: WorkOrderService,
    private visitService : VisitService,
    private router: Router,
    public datepipe: DatePipe) {
  }

  baseUrl!: string;
  filterDto: Array<FilterDto> = [];

  getDataToExcel(filters: FormGroup,brand: string): Observable<ExportResponse> {
    let url = this.userService.getClientBaseUrl() + '/brand/' + brand ;
    if(this.router.url === '/'){
      url = url + this.workOrderService.baseUrl;
    } else {
      url = url + this.visitService.baseUrl;
    }

    let user: User = this.userService.getUser();
    const userDetailDto = {} as UserData;
    userDetailDto.userName = user.name;
    userDetailDto.userEmail = user.email;
    if ((filters && (typeof filters.value.multipleFilterarray != "undefined"
      && filters.value.multipleFilterarray != null
      && filters.value.multipleFilterarray.length != null
      && filters.value.multipleFilterarray.length > 0))) {
        url = url + "/filters/export";
        this.createBody(filters);
        let body = {
          userDetailDto,
          "arrayFilterListDTO" : {
            filterListDTO: this.filterDto
          }

        };
        this.filterDto = [];
        return this.http.post<ExportResponse>(url, body);

    }
    else if (filters && filters.value.tableFilter.column === "workOrderNumber") {
      url = this.userService.getClientAndFmSystemBaseUrl() + '/brand/' + brand + '/workorderlist/export';
      let user: User = this.userService.getUser();
      const userDetailDto = {} as ExportData;
      userDetailDto.userName = user.name;
      userDetailDto.userEmail = user.email;
      userDetailDto.woList = filters.value.value;
      this.filterDto = [];
      return this.http.post<ExportResponse>(url, userDetailDto);
    }
    else if (filters && filters.value.tableFilter.column === "workOrderId") {
      url = this.userService.getClientAndFmSystemBaseUrl() + '/brand/' + brand  + '/visitlist/export';
      let user: User = this.userService.getUser();
      const userDetailDto = {} as ExportData;
      userDetailDto.userName = user.name;
      userDetailDto.userEmail = user.email;
      userDetailDto.woList = filters.value.value;
      this.filterDto = [];
      return this.http.post<ExportResponse>(url, userDetailDto);
    }
    else {
      if (filters && filters.value && filters.value.tableFilter && filters.value.value) {
        url = url + '/property/' + filters.value.tableFilter.column + '/value/' + filters.value.value + '/export';
      }
      return this.http.post<ExportResponse>(url, userDetailDto)
        .pipe(
          catchError((err) => {
            //console.log('error caught in service')
            console.error(err);

            //Handle the error here

            return throwError(err);    //Rethrow it back to component
          })
        );
    }
  }

  private createBody(filters: FormGroup) {
    filters.value.multipleFilterarray.forEach((element: MultipleFilterProperty) => {
      let dto = new FilterDto();

      if (element.column == Constants.dateConst) {
        if (element.dateBackendName == Constants.dateReceived) {
          dto.property = Constants.backendDateReceived;
        } else {
          dto.property = Constants.backendScheduledStartDate;
        }

        let start_date = this.datepipe.transform(element.origionalStartDateFormat, Constants.backendDateFormat);
        let end_date = this.datepipe.transform(element.origionalEndDateFormat, Constants.backendDateFormat);
        dto.value = start_date + " = " + end_date;
      } else {
        dto.property = element.column;
        dto.value = element.value;
      }

      this.filterDto.push(dto);
    });
  }

}
